var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_335_55294)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M479 43L479 45L1 45L1 43L479 43Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 44,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 44.0001,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 303,
  cy: 44.0001,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 444,
  cy: 44.0001,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 31,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 10,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.52,
  x: 41,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.54,
  x: 51,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.56,
  x: 61,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.58,
  x: 71,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.6,
  x: 81,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.62,
  x: 91,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.64,
  x: 101,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.66,
  x: 111,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.68,
  x: 121,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.68,
  x: 131,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.7,
  x: 141,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.72,
  x: 151,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.74,
  x: 172,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.76,
  x: 182,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.78,
  x: 192,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.8,
  x: 202,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.82,
  x: 212,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.84,
  x: 222,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.86,
  x: 232,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.88,
  x: 242,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.9,
  x: 252,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.92,
  x: 262,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.94,
  x: 272,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.96,
  x: 282,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.98,
  x: 292,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.98,
  x: 454,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  x: 313,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  x: 323,
  y: 22,
  width: 1,
  height: 18,
  fill: "#666666"
}), /*#__PURE__*/React.createElement("rect", {
  x: 333,
  y: 20,
  width: 1,
  height: 20,
  fill: "#4D4D4D"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.95,
  x: 343,
  y: 14,
  width: 1,
  height: 26,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  x: 353,
  y: 6,
  width: 1,
  height: 34,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.95,
  x: 363,
  y: 2,
  width: 1,
  height: 38,
  fill: "#1A1A1A"
}), /*#__PURE__*/React.createElement("rect", {
  x: 373,
  width: 1,
  height: 40,
  fill: "#1A1A1A"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.95,
  x: 383,
  y: 2,
  width: 1,
  height: 38,
  fill: "#1A1A1A"
}), /*#__PURE__*/React.createElement("rect", {
  x: 393,
  y: 6,
  width: 1,
  height: 34,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.95,
  x: 403,
  y: 14,
  width: 1,
  height: 26,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  x: 413,
  y: 20,
  width: 1,
  height: 20,
  fill: "#4D4D4D"
}), /*#__PURE__*/React.createElement("rect", {
  x: 423,
  y: 22,
  width: 1,
  height: 18,
  fill: "#666666"
}), /*#__PURE__*/React.createElement("rect", {
  x: 433,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_335_55294"
}, /*#__PURE__*/React.createElement("rect", {
  width: 464,
  height: 52,
  fill: "white"
})));
function SvgTimeBoundIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 52,
    viewBox: "0 0 464 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBoundIllustration);
export default __webpack_public_path__ + "static/media/time-bound-illustration.2a955f6a022ad7902de37c9311d478e4.svg";
export { ForwardRef as ReactComponent };